import { Projekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { Observable } from 'rxjs'

export interface ProjektinVarit {
  varikoodi: string
  taustavari: string
}

export const PROJEKTI_VARIT: ProjektinVarit[] = [
  { varikoodi: '#3a8a5b', taustavari: '#e3f0e8' },
  { varikoodi: '#6f54c7', taustavari: '#ebe6f7' },
  { varikoodi: '#c47429', taustavari: '#f9ead6' },
  { varikoodi: '#2f7d97', taustavari: '#dceef3' },
  { varikoodi: '#d83a3a', taustavari: '#fce8e8' },
  { varikoodi: '#2d9a5e', taustavari: '#dff4e7' },
  { varikoodi: '#8a4fc4', taustavari: '#f0e7f7' },
  { varikoodi: '#d67c29', taustavari: '#faeedd' },
]

export abstract class ProjektitService {
  abstract naytettavatKirjanpitoprojektitObservable: Observable<Projekti[]>
  abstract naytaProjektitObservable: Observable<boolean>
  abstract annaProjektinVarit(projektiAvain: string): ProjektinVarit
}
